import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { queryKeys } from "@/lib/queryKeys";
import { Dashboard } from "./-dashboard";
import { Skeleton } from "@/components/Skeleton";

function Home() {
  const me = useQuery({ queryKey: queryKeys.me(), queryFn: api.me });
  if (me.isLoading) return <Skeleton height={400} />;
  return <Dashboard userName={me.data?.user.name ?? "there"} />;
}

export const Route = createFileRoute("/")({
  component: Home,
});
